export default [

     {
          path: '/crise-type',
          name: 'CriseType',
          component: () => import("@/views/Page/CriseType/CriseType.vue"),
           meta: {
               title: '#Default# | CriseType',
          },
     }
];